let alert;
let language = localStorage.getItem("PCMSClientLanguage");
if (language == 2) {
  // English - En
  alert = {
    success: {
      save: "Saved successfully",
      send: "Your information has been sent successfully",
      submit: "The information has been successfully submitted",
      done: "mission accomplished",
      edit: "The information has been edited successfully",
      delete: "Successfully deleted",
    },
  };
} else if (language == 1) {
  // Arabic - Ar
  alert = {
    success: {
      save: "حفظ بنجاح",
      send: "اطلاعات شما با موفقیت ارسال شد",
      submit: "مسجل بنجاح",
      done: "با موفقیت انجام شد",
      edit: "اطلاعات مدنظر با موفقیت ویرایش شد",
      delete: "با موفقیت حذف شد",
      commentSent: "نظر شما ارسال شد و پس از تایید در سایت درج خواهد شد",
    },
    error: {
      access: "متاسفانه شما به این قسمت دسترسی ندارید",
      notFound: "اطلاعات درخواستی وجود ندارد",
      pageNotFound: "متاسفانه هنوز داده ای وجود ندارد",
      server: "مشکلی در برقراری ارتباط با سرور وجود دارد",
      post: "مشکلی در انجام عملیات وجود دارد. مجدد تلاش کنید",
      upload: "حجم و یا پسوند فایل مدنظر غیرمجاز می‌باشد",
      empty: "لطفا فیلدهای الزامی را وارد کنید",
      emptyTitle: "لطفا عنوان را وارد کنید",
      emptyComment: "لطفا نظر خود را بنویسید",
      captcha: "کد کپچا معتبر نمی‌باشد",
      emptyFields: "لطفا موارد الزامی را وارد کنید",
    },
  };
} else {
  // Farsi - Fa  (Default Language)
  alert = {
    success: {
      save: "با موفقیت ذخیره شد",
      send: "اطلاعات شما با موفقیت ارسال شد",
      submit: "اطلاعات شما با موفقیت ثبت شد",
      done: "با موفقیت انجام شد",
      edit: "اطلاعات مدنظر با موفقیت ویرایش شد",
      delete: "با موفقیت حذف شد",
      commentSent: "نظر شما ارسال شد و پس از تایید در سایت درج خواهد شد",
    },
    error: {
      access: "متاسفانه شما به این قسمت دسترسی ندارید",
      notFound: "اطلاعات مدنظر وجود ندارد",
      pageNotFound: "هنوز مطلبی وجود ندارد",
      server: "مشکلی در برقراری ارتباط با سرور وجود دارد",
      post: "مشکلی در انجام عملیات وجود دارد. مجدد تلاش کنید",
      upload: "حجم و یا پسوند فایل مدنظر غیرمجاز می‌باشد",
      empty: "لطفا فیلدهای الزامی را وارد کنید",
      emptyTitle: "لطفا عنوان را وارد کنید",
      emptyComment: "لطفا نظر خود را بنویسید",
      wrongMobile: "لطفا شماره همراه به صورت صحیح وارد کنید",
      mobileNotFound: "شماره همراه وارد شده یافت نشد",
      captcha: "کد کپچا معتبر نمی‌باشد",
      emptySelect: "هیچ موردی انتخاب نشده است",
    },
  };
}

export default alert;
